import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import {all_routes} from "../../../../router/all_routes";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Field,Message,Title,Type,Url} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Toast_Message,Template,Storage,System,User} from "../../../../../project";
import {DateTime,Log,Str} from "biz9-utility";
import {Image_Type,Image_Field,Image_Format} from "biz9-image";
import {Stat_Table} from "biz9-stat";
import {Data_Logic} from "biz9-data-app";
import {User_Logic,User_Stat} from "biz9-user";
 import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table} from "biz9-portal-app";
/* -- biz9 import end -- */
const Dashboard_User_Profile_Detail = () => {
   const [user,setUser] = useState(User.get());
    const [val_last_login,setValLastLogin] = useState("N/A");
  useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            },[]);
    async function get_data()
    {
        let search = Data_Logic.get_search(Stat_Table.STAT,{user_id:user.id,stat_type:User_Stat.POST_LOGIN});
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);
        if(data.items.length>0){
            bind_field(DateTime.get_date_time(data.items[0].date_create));
        }
        Toast_Message.dismiss();
    };
    async function bind_field(data){
        setValLastLogin(DateTime.get_date_time(data.date_create));
    };
  return (
    <>
 <Toaster />
      {/* Page Content */}
      <div className="page-wrapper">
        <div className="page-content content">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="main-title mb-4">
                <h4>Profile</h4>
              </div>
              <div className="card profile-card">
                <div className="card-body">
                  <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
                    <div className="d-flex align-items-center flex-shrink-0">
                      <span className="avatar avatar-lg">
                        <ImageWithBasePath className="rounded-2" src={Image.get_url(user[Image_Field.IMAGE_FILENAME],Image_Format.SQUARE_THUMB)}
                        alt="img" />
                        </span>
                      <div className="ms-3">
                        <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
                          {user.username?user.username:"N/A"}
                        </h6>
                        <p className="mb-2">{User_Logic.get_country_state_city(user)}</p>
                      </div>
                    </div>
                    <Link to={all_routes.dashboard_user_profile_edit} className="btn btn-lg btn-dark">
                      Edit
                    </Link>
                  </div>
                </div>
              </div>
              <div className="card profile-details">
                <div className="card-header">
                  <h5 className="mb-0">Personal Details</h5>
                </div>
                <div className="card-body">
                  <div className="row row-gap-3">
                    <div className="col-md-4 col-sm-6">
                      <h6>First Name</h6>
                      <p className="mb-0">{user.first_name?Str.get_title(user.first_name):"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Last Name</h6>
                      <p className="mb-0">{user.last_name?Str.get_title(user.last_name):"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Email</h6>
                      <p className="mb-0">{user.email?user.email:"N/A"}</p>
                    </div>

                    <div className="col-md-4 col-sm-6">
                      <h6>Member Since</h6>
                      <p className="mb-0">{DateTime.get_date_short(user.date_create)}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Gender</h6>
                      <p className="mb-0">{user.gender?user.gender:"N/A"}</p>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <h6>Last Login</h6>
                      <p className="mb-0">{DateTime.get_date(user.last_login)}{" "}{DateTime.get_time(user.last_login)}</p>
                    </div>

                    <div className="col-md-4 col-sm-6">
                      <h6>ID</h6>
                      <p className="mb-0">{user.id}</p>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </>
  );
};

export default Dashboard_User_Profile_Detail;
